import { NibbleType } from '@aipb/gulliver/personal-content/model';

import { Component, Input, ViewEncapsulation } from '@angular/core';
import { SizeProp, Styles } from '@fortawesome/fontawesome-svg-core';
import { TranslocoModule } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'pc-shared-nibble-type-icon',
  templateUrl: './nibble-type-icon.component.html',
  styleUrls: ['./nibble-type-icon.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, MatIconModule, TranslocoModule]
})
export class NibbleTypeIconComponent {
  @Input() type: NibbleType | 'COLL_CUSTOM' = 'REC';
  @Input() size: SizeProp;
  @Input() fixedWidth = false;
  @Input() disabled = false;

  get title(): string {
    return 'personal_content.nibble_types.' + this.type;
  }

  getIcon(): string {
    switch (this.type) {
      case 'REC':
        return 'description';
      case 'RECDBOX':
        return 'deployed_code';
      case 'TXT':
        return 'text_fields';
      case 'SRCH':
        return 'feature_search';
      case 'COLL':
        return 'layers';
      case 'COLL_CUSTOM':
        return 'layers';
      case 'DOC':
      case 'DOC3IF':
        return 'book';
      case 'PAGE':
        return 'import_contacts';
      case 'IMG':
        return 'image';
      case 'IMG3F':
        return 'import_contacts';
      case 'CROP':
        return 'crop';
      case 'VID':
        return 'videocam';
      case 'AUD':
        return 'volume_up';
      case 'LINK':
        return 'link';
    }

    return 'description';
  }

  getStyles(): Styles {
    const styles: Styles = {};

    const primaryColor = '--fa-primary-color';
    const secondaryColor = '--fa-secondary-color';
    const primaryOpacity = '--fa-primary-opacity';
    const secondaryOpacity = '--fa-secondary-opacity';

    if (this.disabled) {
      styles[primaryColor] = '#bbbbbb';
      styles[secondaryColor] = '#212121';
      styles[primaryOpacity] = '0.3';
      styles[secondaryOpacity] = '0.3';
      styles['color'] = '#aaaaaa';
      return styles;
    }

    switch (this.type) {
      case 'REC':
        styles[primaryColor] = '#990012';
        styles[secondaryColor] = '#bbbbbb';
        styles[primaryOpacity] = '0.7';
        styles[secondaryOpacity] = '0.6';
        break;
      case 'RECDBOX':
        styles['color'] = '#52a3f3';
        break;
      case 'TXT':
        styles[primaryColor] = '#dddddd';
        styles[secondaryColor] = '#2B547E';
        styles[primaryOpacity] = '1.0';
        styles[secondaryOpacity] = '0.9';
        break;
      case 'SRCH':
        styles[primaryColor] = '#990012';
        styles[secondaryColor] = '#bbbbbb';
        styles[primaryOpacity] = '0.7';
        styles[secondaryOpacity] = '0.6';
        break;
      case 'COLL':
        styles['color'] = '#2B547E';
        break;
      case 'COLL_CUSTOM':
        styles[primaryColor] = '#2B547E';
        styles[secondaryColor] = '#212121';
        styles[primaryOpacity] = '0.9';
        styles[secondaryOpacity] = '0.6';
        break;
      case 'DOC':
      case 'DOC3IF':
        styles[primaryColor] = '#FBB917';
        styles[secondaryColor] = '#212121';
        styles[primaryOpacity] = '0.8';
        styles[secondaryOpacity] = '0.5';
        break;
      case 'PAGE':
        styles[primaryColor] = '#FBB917';
        styles[secondaryColor] = '#212121';
        styles[primaryOpacity] = '0.8';
        styles[secondaryOpacity] = '0.5';
        break;
      case 'IMG':
        styles[primaryColor] = '#212121';
        styles[secondaryColor] = '#FBB917';
        styles[primaryOpacity] = '0.5';
        styles[secondaryOpacity] = '0.9';
        break;
      case 'IMG3F':
      case 'CROP':
        styles[primaryColor] = '#212121';
        styles[secondaryColor] = '#FBB917';
        styles[primaryOpacity] = '0.4';
        styles[secondaryOpacity] = '0.8';
        break;
      case 'VID':
        styles[primaryColor] = '#f00';
        styles[secondaryColor] = '#212121';
        styles[primaryOpacity] = '0.7';
        styles[secondaryOpacity] = '0.5';
        break;
      case 'AUD':
        styles[primaryColor] = '#438D80';
        styles[secondaryColor] = '#212121';
        styles[primaryOpacity] = '0.9';
        styles[secondaryOpacity] = '0.5';
        break;
      case 'LINK':
        styles[primaryColor] = '#438D80';
        styles[secondaryColor] = '#212121';
        styles[primaryOpacity] = '0.9';
        styles[secondaryOpacity] = '0.5';
        break;
    }

    return styles;
  }
}
